// City.jsx
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import IcdqModal from "../../AppComponents/icdqmodal/icdqmodal";

const City = () => {
  const screenfields = [
    {
      caption: "Code",
      field: "code",
      type: "text",
      required: true,
      spacefield: 3,
    },
    {
      caption: "Country",
      fieldtype: "dropdown",
      field: "countryid",
      required: true,
      fieldwidth: 3,
      valuefield: "id",
      displayfield: "country",
      endpoint: "countries",
    },
    {
      caption: "State",
      fieldtype: "dropdown",
      field: "stateid",
      spacefield: 2,
      required: true,
      fieldwidth: 3,
      valuefield: "id",
      displayfield: "state",
      dependentOn: "countryid", // Added dependentOn
      endpoint: "statesByCountry",
    },
    {
      caption: "City",
      field: "city",
      type: "text",
      required: true,
      spacefield: 3,
      fieldwidth: 6,
    },
  ];

  const tableColumns = [
    { field: "code", label: "Code", width: 20 },
    { field: "city", label: "City", width: 100 },
    { field: "state", label: "State", width: 100 },
    { field: "country", label: "Country", width: 100 },
  ];

  return (
    <IcdqModal
      GridWidth="60"
      FieldsArr={screenfields}
      title="City"
      controller="cities"
      GridColumns={tableColumns}
      PrimaryKeyField="id"
    />
  );
};

export default City;
